// Rempli par la passe de traduction (memes cles que fr/).
export default {};
